import React, { Component } from 'react'

class SimpleText extends Component {
    render() {
        const { content, css } = this.props

        return (
            <div className="container">
                <div className={`row text-center ${css}`}>
                    <div className=" text-center" style={{ margin: 'auto' }}>
                        {content.title && <h2 className="text-center lined">{content.title}</h2>}
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: content.text }} className="col-lg-12" />
                </div>
            </div>
        )
    }
}

export { SimpleText }


// WEBPACK FOOTER //
// ./src/components/sections/SimpleText.js